import type { BulkCreateRests, Rest } from '@libs/data-access/entities'
import { chunk } from 'lodash-es'

import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'

import type { RestSchema } from './types/Rest.schema'

export type BulkDeleteRestsListOptions = QueryFnParams<{
  payload: { rest_ids: number[] }
}>

export type BulkCreateRestsListOptions = QueryFnParams<{
  payload: BulkCreateRests
}>

export const bulkDeleteRestsList = async (
  opts?: BulkDeleteRestsListOptions
) => {
  const maxRestPerRequest = 50 // Value provided by the API
  const allRestIds = opts?.payload?.rest_ids

  const chunkedRestIds = chunk(allRestIds, maxRestPerRequest)
  const restsPromises = chunkedRestIds.map(restIds =>
    httpServices.core.delete('/rests/bulk_delete', {
      data: { rest_ids: restIds }
    })
  )

  await Promise.all(restsPromises)
}

export const bulkCreateRestsList = async (
  opts?: BulkCreateRestsListOptions
) => {
  const response = await httpServices.core.post(
    '/rests/bulk_create',
    opts?.payload
  )
  return response.data
}

export type PostRestOptions = QueryFnParams<{
  payload: Partial<Rest>
}>
export const postRest = async (opts: PostRestOptions) => {
  const response = await httpServices.core.post(`/rests`, opts.payload)
  return response.data
}

/**
 * Fetch one rest
 *
 */
export type FetchRestOptions = QueryFnParams<{
  pathParams: { id: number }
}>

export const fetchRest = async (opts: FetchRestOptions) => {
  const response = await httpServices.core.get<RestSchema>(
    `/rests/${opts?.pathParams.id}`
  )
  return response.data
}
